import * as ordersCancelled from './cancelled'
import * as ordersExpired from './expired'
import * as ordersInPreparation from './inPreparation'
import * as ordersOnDelivery from './onDelivery'
import * as ordersReady from './ready'
import * as ordersRemoved from './removed'
import * as ordersRetrieved from './retrieved'
import * as ordersRetrievedBySomeOneElse from './retrievedBySomeOneElse'

import { Order } from 'app/types/operations/order'

export const allOrders: Order[] = [
    ...Object.values(ordersInPreparation),
    ...Object.values(ordersOnDelivery),
    ...Object.values(ordersReady),
    ...Object.values(ordersRetrieved),
    ...Object.values(ordersCancelled),
    ...Object.values(ordersExpired),
    ...Object.values(ordersRetrievedBySomeOneElse),
    ...Object.values(ordersRemoved),
].sort((previous, current) => current.id - previous.id)
